<template>
  <div class="mdp-header">
    <LogoIcon/>
  </div>
</template>

<script setup>

import LogoIcon from '../icons/LogoIcon.vue'
</script>

<style scoped lang="scss">
 .mdp-header{
   background-color: var(--app-color-primary);
 }
</style>
